import {Address} from './address.model';
import {GenericEntity} from './generic-entity.model';
import {SystemFile} from './system-file.model';
import {PasswordPolicy} from './password-policy.model';
import {PartnerOperation} from '../enums/operations.enum';
import {sortBy} from '../helpers/array.helper';
import {DictionaryItem} from './dictionary.model';

export class Partner extends GenericEntity {
    address: Address = new Address();
    assortmentGroups: string[];
    barcodeAlgorithm: string;
    code: string;
    isActive = true;
    isBarcode: boolean;
    isPrintClientSection: boolean;
    isSellWs: boolean;
    isSellWww: boolean;
    isVirtual: boolean;
    nameFull: string;
    nameShort: string;
    phone: string;
    phoneCallCenter: string;
    policyPrefixCode: string;
    policyPrefixPartnerCode: string;
    securityPolicy: PasswordPolicy;
    signatureFile: SystemFile;
    availableOperations: PartnerOperation[];
    nip: string;
    regon: string;
    legalForm: DictionaryItem;

    constructor(props = {}) {
        super(props);
        Object.assign(this, props);

        if (Array.isArray(this.assortmentGroups)) {
            this.assortmentGroups = sortBy(this.assortmentGroups, 'description');
        }
    }

    isOperationEnabled(operation: PartnerOperation) {
        return this.availableOperations?.includes(operation);
    }
}

export class PartnerIdentity {
    id: number;
    code: string;
    nameFull: string;
    nameShort: string;
    isVirtual: boolean;
    isActive = true;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class PartnerListFilter {
    search: boolean;
    sellActive: boolean;
    active: boolean;
    virtual: boolean;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}
